export enum EmailTemplateContentValidationErrorEnum {
  MinSize = "MIN_SIZE",
  MaxSize = "MAX_SIZE",
}
